/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_close = /** @type {(inputs: {}) => string} */ () => {
	return `Zavřít`
};

const da_close = /** @type {(inputs: {}) => string} */ () => {
	return `Luk`
};

const de_close = /** @type {(inputs: {}) => string} */ () => {
	return `Schließen`
};

const en_close = /** @type {(inputs: {}) => string} */ () => {
	return `Close`
};

const es_close = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar`
};

const fr_close = /** @type {(inputs: {}) => string} */ () => {
	return `Fermer`
};

const hu_close = /** @type {(inputs: {}) => string} */ () => {
	return `Bezárás`
};

const it_close = /** @type {(inputs: {}) => string} */ () => {
	return `Chiudi`
};

const nl_close = /** @type {(inputs: {}) => string} */ () => {
	return `Sluiten`
};

const pl_close = /** @type {(inputs: {}) => string} */ () => {
	return `Zamknij`
};

const pt_close = /** @type {(inputs: {}) => string} */ () => {
	return `Fechar`
};

const sv_close = /** @type {(inputs: {}) => string} */ () => {
	return `Stäng`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const close = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.close(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("close", locale)
	if (locale === "cs") return cs_close(inputs)
	if (locale === "da") return da_close(inputs)
	if (locale === "de") return de_close(inputs)
	if (locale === "en") return en_close(inputs)
	if (locale === "es") return es_close(inputs)
	if (locale === "fr") return fr_close(inputs)
	if (locale === "hu") return hu_close(inputs)
	if (locale === "it") return it_close(inputs)
	if (locale === "nl") return nl_close(inputs)
	if (locale === "pl") return pl_close(inputs)
	if (locale === "pt") return pt_close(inputs)
	return sv_close(inputs)
};